import { useEffect } from "react";

const BASE = "https://phousebd.com";
const DEFAULT_TITLE = "PromptsHouseBD — Master AI, Step by Step";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, description, path, type = "website", jsonLd }) {
  useEffect(() => {
    const fullTitle = title ? `${title} — PromptsHouseBD` : DEFAULT_TITLE;
    const desc = description || "PromptsHouseBD — free step-by-step AI lessons, a ready-to-use prompt library, and daily AI news that matters.";
    const url = BASE + (path || window.location.pathname);

    document.title = fullTitle;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", type);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    let script = document.getElementById("seo-jsonld");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.id = "seo-jsonld";
        script.type = "application/ld+json";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [title, description, path, type, jsonLd]);
  return null;
}
